<div class='modal-dialog modal-lg' role='document'>
  <div class='modal-content bg-modal' style='width: 100%; max-width: 480px; height: 500px; display: flex; flex-direction: column;'>
    <div
      class='modal-header dark-blue flex justify-content-between align-items-start ps-4 pt-4 pb-3 pe-4 border-1 border-white border-bottom'
    >
      <h2 class='modal-title text-white me-auto fs-3'>
        {{ 'you_do_know' | translate }}
      </h2>
      @if (many()) {
      <div class="form-check me-1">
        <label class="checkbox-group">
          <input type="checkbox" [formControl]="showControl()" />
          <span class="checkmark"></span>
        </label>
        <label style="color: white" class="form-check-label me-1 align-top">
      {{ '$no_volver_a_mostrar' | translate }}
      </label>
    </div>
      }
      <span [style.cursor]="'pointer'" class='white' (click)='dialogRef.close()'>X</span>
    </div>

    @if (many()) {
    <div class="mb-0" style="flex-grow: 1; display: flex; justify-content: center; align-items: center; overflow: hidden; height: 500px;">
      @for (c of curiosities(); track c.id) {
    @if ($index === actualPage()) {
    <img class="w-100" [lazyLoad]="c.language.image | cdnUrl: 800 : true"  style="width: auto; height: auto; min-width: 100%; max-height: 100%; object-fit: contain; object-position: center;"
alt="" />
    }

    }
    </div>
    } @else {
    <div class="mb-0" style="flex-grow: 1; display: flex; justify-content: center; align-items: center; overflow: hidden; height: 500px;">
      <img
        class="w-100 curiosity-img"
        [lazyLoad]="curiosity()?.language?.image | cdnUrl: 800 : true" style="width: auto; height: auto; min-width: 100%; max-height: 100%; object-fit: contain; object-position: center;"
        alt="" />
    </div>
    }

    @if (many()) {
    <div class="sabias-pages d-flex align-items-center justify-content-between width-modal-curiosity">
      <span (click)="left()" class="carousel-control-prev-icon cursor-pointer" aria-hidden="true"></span>
      <span class="bold-text"
        >{{ actualPage() + 1 }} {{ 'de' | translate }} {{ curiosities().length }}</span
        >
        <span (click)="right()" class="carousel-control-next-icon cursor-pointer" aria-hidden="true"></span>
      </div>
    } @else {
    <div class="sabias-pages d-flex align-items-center justify-content-between width-modal-curiosity">
      <div class="mt-2">
        <label class="checkbox-group">
          <input [formControl]="showControl()" type="checkbox" />
          <span class="checkmark"></span>
        </label>
        <label class="form-check-label align-top white-text">
    {{ 'not_show_this_message' | translate }}
    </label>
  </div>
  <div class="float-end d-inline">
    <button (click)="dialogRef.close()" class="white-border rounded-2">
    {{ 'close' | translate }}
    </button>
    <div class="mx-1 d-inline-block"></div>
    <button
      class="yellow dark-blue-text rounded-2"
      (click)="dialogRef.close(); moreCuriosities()"
    >
    {{ 'more_curiosities' | translate }}
    </button>
  </div>
</div>
    }
  </div>
</div>
